var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogout = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m19.514 11.454-8.5-8-1.028 1.092 7.123 6.704H2v1.5h15.109l-7.123 6.704 1.028 1.092 8.5-8 .58-.546-.58-.546ZM21.25 3v18h1.5V3h-1.5Z"
})));
export { SvgLogout as ReactComponent };
export default __webpack_public_path__ + "f7e5dcdd08e54ac64d5638b066dbd54d.svg";